import { ThreeDots } from "react-loader-spinner";
import Loading from "./Loading";
import InfiniteScroll from "react-infinite-scroll-component";


const AppInfiniteScroll = ({
    children,
    data,
    loadMore = () => { },
    hasMore = true,
    refreshFunction = () => { },
    page = 1,
    pullDownToRefreshContent = "당겨서 새로고침...",
    className,
    pullDownToRefresh = true
}) => {
    return <InfiniteScroll
        dataLength={data.length}
        next={loadMore}
        hasMore={hasMore}
        loader={
            <div className="nl-row j-center pb-20">
                <Loading width="40" height="40" />
            </div>
        }
        endMessage={
            <p className="text-center htNoMore">
                {data.length > 0 && page > 1 ? '더 이상 로드할 데이터가 없습니다.' : ''}
            </p>
        }
        refreshFunction={refreshFunction}
        pullDownToRefresh={pullDownToRefresh}
        pullDownToRefreshThreshold={100}
        pullDownToRefreshContent={
            <div className="nl-row j-center pb-10 htNoMore">
                {pullDownToRefreshContent}
            </div>
        }
        releaseToRefreshContent={
            <div className="nl-row j-center a-center"  style={{ height: 20, paddingBottom: '0px'}}>
                <ThreeDots
                    visible={true}
                    height="40"
                    width="40"
                    color="#4fa94d"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperClass="htThreeDots"
                />
            </div>
        }
        className={className}


    >
        {children}
    </InfiniteScroll>
}

export default AppInfiniteScroll;